import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "arrow"]

  connect() {
    this.open = false
    this.outsideClick = this.close.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    this.open = !this.open
    this.menuTarget.classList.toggle("sidebar__locale-dropdown--open", this.open)
    this.arrowTarget.classList.toggle("sidebar__locale-arrow--open", this.open)

    if (this.open) {
      document.addEventListener("click", this.outsideClick)
    } else {
      document.removeEventListener("click", this.outsideClick)
    }
  }

  close() {
    this.open = false
    this.menuTarget.classList.remove("sidebar__locale-dropdown--open")
    this.arrowTarget.classList.remove("sidebar__locale-arrow--open")
    document.removeEventListener("click", this.outsideClick)
  }
}
